export default __webpack_public_path__ + "static/media/23.40f5165d.jpg";